import React from "react";
import { DialogContent } from "@material-ui/core";
import FixedPositionDialog from "../../../elements/FixedPositionDialog";
import DialogTitleWithCloseIcon from "../../../elements/DialogTitleWithCloseIcon";
import I18nText from "../../../elements/I18nText";
import ExportEmailContainer from "./ExportEmailContainer";

const ExportEmailDialog = ({ onClose }) => {
  return (
    <FixedPositionDialog open={true} scroll="body" fullWidth={true}>
      <DialogTitleWithCloseIcon onClose={() => onClose()}>
        <I18nText>devices.export.emailRequired.title</I18nText>
      </DialogTitleWithCloseIcon>
      <DialogContent>
        <ExportEmailContainer onClose={onClose} />
      </DialogContent>
    </FixedPositionDialog>
  );
};

export default ExportEmailDialog;
